'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * @param params
     * @param {string} params.login email address
     * @param {string} params.deviceId
     * @param {number} params.password
     * @param {string} params.firstName
     * @param {string} params.lastName
     * @param {string} params.birthdate
     * @param {string} params.postal
     * @param {string} params.gender
     * @param {string} params.lang
     * @param {string} params.cntry
     * @param {string} params.optIn
     * @param {string} params.currency
     * @param {string} params.terms
     * @param {string} params.securityQuestionId
     * @param {string} params.securityQuestionAnswer
     * @returns {Bluebird Promise}
     */
    bootstrapEcommerce: function bootstrapEcommerce(params) {
        var postdata = {};
        if (params.deviceId) {
            postdata.deviceId = params.deviceId;
        }

        if (params.token) {
            postdata.token = params.token;
        }
        if (params.devicePrintId) {
            postdata.devicePrintId = params.devicePrintId;
        }
        var qs = this.pullQueryStringParams(params);

        return this.postApiRequest(this.getUrl().bootstrapEcommerce, qs, postdata);
    },

    bootstrapMy: function bootstrapMy(params) {
        var postdata = {};
        if (params.deviceId) {
            postdata.deviceId = params.deviceId;
        }

        if (params.token) {
            postdata.token = params.token;
        }
        if (params.devicePrintId) {
            postdata.devicePrintId = params.devicePrintId;
        }
        var qs = this.pullQueryStringParams(params);

        return this.postApiRequest(this.getUrl().bootstrapMy, qs, postdata);
    },

    create: function create(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().createProfile, qs, params);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @returns {Bluebird Promise}
     */
    summary: function summary(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().getProfile, qs, params);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @param {string} params.login
     * @param {number} params.password
     * @param {string} params.firstName
     * @param {string} params.lastName
     * @param {string} params.gender
     * @param {string} params.cntry
     * @param {string} params.postal
     * @param {string} params.securityQuestionId
     * @param {string} params.securityQuestionAnswer
     * @param {string} params.isVeteranMember
     * @param {string} params.currency
     * @param {string} params.lang
     * @param {string} params.optIn
     * @param {string} params.terms
     * @returns {Bluebird Promise}
     */
    update: function update(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().updateProfile, qs, params);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @param {string} params.login
     * @param {string} params.oldPassword
     * @param {string} params.password
     * @returns {Bluebird Promise}
     */
    changePassword: function changePassword(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().changePasswordChange, qs, params);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.token
     * @param {string} params.login
     * @param {number} params.securityQuestionAnswer
     * @returns {Bluebird Promise}
     */
    resetPassword: function resetPassword(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().resetPassword, qs, params);
    },

    getSecurityQuestion: function getSecurityQuestion(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().getSecurityQuestion, qs, params);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.login
     * @returns {Bluebird Promise}
     */
    subscribe: function subscribe(params) {
        if (!params) {
            throw Error('missing params');
        }

        if (!params.login) {
            throw Error('missing login/email');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().subscribe, qs, params);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.verification
     * @returns {Bluebird Promise}
     */
    verificationDetails: function verificationDetails(params) {
        if (!params) {
            throw Error('missing params');
        }

        if (!params.verification) {
            throw Error('missing verification');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().verificationDetails, qs, params);
    },

    /**
     * @param params
     * @param {string} params.deviceId
     * @param {string} params.postal
     * @returns {Bluebird Promise}
     */
    updatePostal: function updatePostal(params) {
        if (!params) {
            throw Error('missing params');
        }

        if (!params.postal) {
            throw Error('missing postal code');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().updatePostal, qs, params);
    },

    /**
     * @param params
     * @param {string} params.redemptionCode
     * @returns {Bluebird Promise}
     */
    giveAwayRedemption: function giveAwayRedemption(params) {
        if (!params) {
            throw Error('missing params');
        }

        if (!params.redemptionCode) {
            throw Error('missing redemption code');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().giveAwayRedemption, qs, params);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/profileServiceClient.js
// module id = 767
// module chunks = 0